import { useState, useEffect } from "react"
import { supabase } from "../../lib/supabaseClient"

export function useProductManager() {
  const empty = {
    name: "",
    category: "",
    price: "",
    description: "",
    address: "",
    geo_lat: "",
    geo_lng: "",
    image_file: null,
  }

  const [form, setForm] = useState(empty)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [showForm, setShowForm] = useState(true)
  const [msg, setMsg] = useState("")

  const load = async () => {
    const { data } = await supabase
      .from("products")
      .select("*")
      .order("created_at", { ascending: false })
    setList(data || [])
  }

  useEffect(() => {
    load()
  }, [])

  const onChange = (e) => {
    const { name, value, files } = e.target
    if (files) setForm((s) => ({ ...s, image_file: files[0] }))
    else setForm((s) => ({ ...s, [name]: value }))
  }

  const uploadImage = async (file) => {
    if (!file) return null
    const ext = file.name.split(".").pop()
    const path = `prod_${Date.now()}.${ext}`
    const { error } = await supabase.storage
      .from("product-images")
      .upload(path, file, { upsert: false })
    if (error) throw error
    const { data } = supabase.storage.from("product-images").getPublicUrl(path)
    return data?.publicUrl || null
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setMsg("")
    setLoading(true)
    try {
      const image_url = await uploadImage(form.image_file)
      const payload = {
        name: form.name,
        category: form.category,
        price: form.price ? Number(form.price) : null,
        description: form.description,
        address: form.address,
        geo_lat: form.geo_lat ? Number(form.geo_lat) : null,
        geo_lng: form.geo_lng ? Number(form.geo_lng) : null,
        image_url,
      }
      const { error } = await supabase.from("products").insert(payload)
      if (error) throw error
      setMsg("✅ Producto creado con éxito")
      setForm(empty)
      setShowForm(false)
      await load()
      setTimeout(() => setShowForm(true), 1500)
    } catch (err) {
      setMsg("❌ " + (err.message || "Error al crear producto"))
    } finally {
      setLoading(false)
    }
  }

  return {
    form,
    setForm,
    list,
    loading,
    showForm,
    setShowForm,
    msg,
    onChange,
    onSubmit,
  }
}
